module.exports = __webpack_public_path__ + "img/nanaronge.06cb2482.jpg";